/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 保存记录用户地区信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  regionRequest: member.MemberRecordRegionRequest,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/member-record-region`,
    data: regionRequest,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
